import React, { useEffect, useState } from 'react';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import LaminasContainer from './laminas/laminas.container';
import InclusaoContainer from './inclusao/inclusao.container';
import Solicitacoes from '../solicitacao/Solicitacoes';
import Total from '../solicitacao/Total';
import { useIntl } from 'react-intl';

function HistologiaPage (props) {
  const intl = useIntl()
  const [currentTab, setCurrentTab] = useState('0');

  useEffect(() => {
    setTimeout(() => {
      setCurrentTab('1');
    }, 200);
  }, []);

  const mudarAba = (event, tab) => {
    setCurrentTab(tab);
  };

  return (
    <div className='mv-histologia-page'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            //scrollButtons='on'
            indicatorColor='primary'
            textColor='primary'
            aria-label='scrollable force tabs example'
          >
            <Tab
              icon={<i className='tab-icons mv-basico-atributo'></i>}
              label={intl.formatMessage({id:'dashboards.histology.histologyInclusion'})}
              value='1'
            />
            <Tab
              icon={<i className='tab-icons mv-basico-espessura'></i>}
              label={intl.formatMessage({id:'dashboards.histology.histologyBlades'})}
              value='2'
            />
            <Tab icon={<Total />} iconPosition="end" label={<span style={{marginRight: '18px'}}>{intl.formatMessage({id:'dashboards.reports.requestsPanel'})}</span>} value='3' />

            <Tab value='0' disabled></Tab>
          </Tabs>
        </AppBar>

        <TabPanel value='0'></TabPanel>
        <TabPanel value='1'>
          <InclusaoContainer {...props} intl={intl} />
        </TabPanel>
        <TabPanel value='2'>
          <LaminasContainer {...props} intl={intl} />
        </TabPanel>
        <TabPanel value='3'>
          <Solicitacoes />
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default HistologiaPage;



// WEBPACK FOOTER //
// ./src/pages/histologia/histologia.page.js